import { render } from "./DVVCriteriaView.vue?vue&type=template&id=a445e9e2"
import script from "./DVVCriteriaView.vue?vue&type=script&lang=js"
export * from "./DVVCriteriaView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__